import { Routes } from '@angular/router';

import { EmployeesLoadedGuard } from '../../../reducers/orm/employee/employees-loaded.guard';
import { canActivateEmployeeOverview } from '../../+employees/guards';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { MyDashboardComponent } from '../../dashboard/my-dashboard/my-dashboard.component';

export const DashboardMenuRoutes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [EmployeesLoadedGuard, canActivateEmployeeOverview],
    children: [
      {
        path: 'my-overview',
        component: MyDashboardComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/dashboard/my-overview',
      },
    ],
  },
];
